import { buildLink, buildOgMeta } from '../../types/builders';
import adapter from './adapter-restaurants-order-page';
var IDs = adapter.IDs;
export var RESTAURANTS_ORDER_PAGE = {
    tags: [
        buildLink({ rel: 'canonical', href: "{{".concat(IDs.PAGE_URL, "}}") }),
        buildOgMeta('og:url', "{{".concat(IDs.PAGE_URL, "}}")),
    ],
};
